(() => {
  'use strict';

  if (customElements.get('press-slider')) return;

  class PressSlider extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.carouselController?.destroy();
      this.carouselController = null;

      window.addEventListener('dieux:swiper:ready', this.mountCarousel, { signal });

      this.mountCarousel();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.carouselController?.destroy();
      this.carouselController = null;
    }

    mountCarousel = () => {
      this.carouselController?.destroy();
      this.carouselController = null;

      const viewport = this.querySelector('[data-press-slider-ref="viewport"]');
      const track = this.querySelector('[data-press-slider-ref="track"]');
      if (!viewport || !track || !window.DieuxSwiper) return;

      this.carouselController = window.DieuxSwiper.mount({
        owner: this,
        viewport,
        track,
        stateTarget: this,
        previousButton: this.querySelector('[data-swiper-button="previous"]'),
        nextButton: this.querySelector('[data-swiper-button="next"]'),
        unavailableControls: this.dataset.pressControls === 'edge' ? 'hidden' : 'disabled',
        mousewheel: true,
        gapProperty: '--press-gap',
        gapSource: this,
        options: {
          slidesPerView: 'auto',
          a11y: {
            enabled: false,
          },
        },
        onStateChange: ({ state, controller }) => {
          if (state === 'enhanced') requestAnimationFrame(() => controller.refresh());
        },
      });
    };
  }

  customElements.define('press-slider', PressSlider);
})();
